import axios from "axios";
import { getToken, getTokenHeader } from "../../../../../screen/auth/action";
import { loginUrl } from "../urls";

export const LoginAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken(); 
    await axios
      .post(
        `${loginUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      }) 
      .catch((err) => {
        return next({ error: true, message: err.response?.data?.message || err.message });
      });
  });
};